<script setup>
import form from '@/components/form.vue';

defineProps({
    blocks: {
        default: () => [],
        type: Array,
    },
});

const blocksMap = {
    form,
};

const makeFormat = (string) => string.replaceAll(/_{1}(.*?)_{1}/g, '<em>$1</em>');
</script>

<template>
    <div
        v-for="block in blocks"
        :key="block.id"
    >
        <div
            v-if="block.typeHandle === 'featuredPartner'"
            class="mb-12 flex flex-wrap justify-between"
        >
            <div
                v-for="featuredPartner in block.featuredPartners"
                :key="featuredPartner.title"
                class="mb-5 flex min-h-[190px] w-full items-center justify-center bg-white p-4 text-center font-bold md:w-1/2 lg:w-32/100"
            >
                {{ featuredPartner.title }}
            </div>
            <div
                class="flex w-full md:w-1/2 lg:w-32/100"
            />
        </div>
        <div
            v-else-if="block.typeHandle === 'partner'"
            class="flex flex-wrap justify-between"
        >
            <div
                v-for="partner in block.partners"
                :key="partner.title"
                class="mb-5 flex min-h-[190px] w-full items-center justify-center bg-white p-4 text-center font-bold md:w-1/2 lg:w-32/100"
            >
                {{ partner.title }}
            </div>
            <div
                class="flex w-full md:w-1/2 lg:w-32/100 "
            />
        </div>
        <div
            v-else-if="block.typeHandle === 'sectionTitle'"
            class="my-10 font-heading leading-none"
            v-html="block.sectionTitle"
        />
        <div
            v-else-if="block.typeHandle === 'titreImage'"
            class="my-10 flex flex-wrap items-center justify-between"
        >
            <div
                class="mb-5 font-heading text-2xl font-light leading-none lg:mb-0 lg:text-4xl"
                v-html="block.sectionTitle"
            />

            <component
                :is="block.sectionLink ? 'a' : 'div'"
                :href="block.sectionLink ?? null"
                :target="block.sectionLink ? '_blank' : null"
            >
                <img
                    v-for="image in block.sectionImage"
                    :key="image.url"
                    :src="image.url"
                    :alt="image.alt"
                    :width="image.width"
                    :height="image.height"
                    class=""
                >
            </component>
        </div>
        <div
            v-else-if="block.typeHandle === 'contentImage'"
            class="my-16 flex flex-wrap"
        >
            <div
                class="txt mb-5 w-full text-lg leading-normal md:text-xl md:leading-normal lg:mb-0 lg:w-1/2"
                v-html="block.contentText"
            />
            <div class="w-full text-right lg:w-1/2">
                <img
                    v-for="image in block.image"
                    :key="image.url"
                    :src="image.url"
                    :alt="image.alt"
                    :width="image.width"
                    :height="image.height"
                    class="inline-block"
                >
            </div>
        </div>
        <div
            v-else-if="block.typeHandle === 'introduction'"
            class="txt text-xl leading-snug md:text-3xl md:leading-snug"
            v-html="block.introduction"
        />
        <div
            v-else-if="block.typeHandle === 'text'"
            class="content-text-img txt mb-12 text-lg leading-normal md:text-xl md:leading-normal"
            v-html="block.textContent"
        />
        <div
            v-else-if="block.typeHandle === 'images'"
            class="mb-10 flex flex-wrap gap-10"
            :class="{
                'items-start': block.imagesLayout == 'column' && block.imagesAlignment === 'left',
                'items-end': block.imagesLayout == 'column' && block.imagesAlignment === 'right',
                'justify-start': block.imagesLayout == 'row' && block.imagesAlignment === 'left',
                'justify-end': block.imagesLayout == 'row' && block.imagesAlignment === 'right',
                'flex-row': block.imagesLayout == 'row',
                'flex-col': block.imagesLayout == 'column'
            }"
        >
            <img
                v-for="image in block.images"
                :key="image.url"
                :src="image.url"
                :alt="image.alt"
                :width="image.width"
                :height="image.height"
                class="shrink-0 grow-0"
                :class="['images-layout-' + block.imagesLayout, 'images-alignment-'+block.imagesAlignment]"
            >
        </div>
        <div
            v-else-if="block.typeHandle === 'table2Columns'"
            class="w-full"
        >
            <table
                class="mb-12 w-full overflow-hidden rounded-t-2xl"
            >
                <tr
                    v-for="( element) in block.table"
                    :key="element.col1"
                    class="odd:bg-[#fce3d6] even:bg-[#fdf1eb]"
                >
                    <!-- <template
                        v-if="i == 0"
                    >
                        <th class="bg-white px-2.5 py-5 text-left lg:px-10">
                            {{ element.col1 }}
                        </th>
                        <th class="bg-white px-2.5 py-5 text-left lg:px-10">
                            {{ element.col2 }}
                        </th>
                    </template> -->

                    <td class="p-2.5 lg:px-10" v-html="makeFormat(element.col1)" />
                    <td class="p-2.5 font-bold lg:px-10">
                        {{ element.col2 }}
                    </td>
                </tr>
            </table>
        </div>
        <div
            v-else-if="block.typeHandle === 'form'"
            class=""
        >
            <component :is="blocksMap[block.typeHandle]" :data="block" />
        </div>
        <div v-else>
            {{ block.typeHandle }}
        </div>
    </div>
</template>
